import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const HEADING = { color: '#1e3a5f', fontSize: 19, fontWeight: 700, marginBottom: 10, marginTop: 44, paddingBottom: 8, borderBottom: '1px solid #e2e8f0' };
const BODY    = { color: '#334155', fontSize: 15, lineHeight: 1.9, marginTop: 8 };
const LI      = { marginBottom: 6 };

export default function TermsOfService() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#fff', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <div style={{ flex: 1, maxWidth: 800, margin: '0 auto', padding: '80px 40px', width: '100%', boxSizing: 'border-box' }}>

        <Link
          to="/"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#64748b', fontSize: 14, textDecoration: 'none', marginBottom: 48 }}
          onMouseEnter={e => (e.currentTarget.style.color = '#1e3a5f')}
          onMouseLeave={e => (e.currentTarget.style.color = '#64748b')}
        >
          ← トップに戻る
        </Link>

        <h1 style={{ fontSize: 34, fontWeight: 800, color: '#1e3a5f', marginBottom: 12, letterSpacing: '-0.02em' }}>
          利用規約
        </h1>
        <p style={{ color: '#94a3b8', fontSize: 14, marginBottom: 48 }}>
          制定日：2025年4月25日　　運営：髙正堂株式会社（TAKAMASADO Inc.）
        </p>

        <div style={{ borderTop: '2px solid #e2e8f0', paddingTop: 40 }}>

          <h2 style={HEADING}>第1条（サービスの目的）</h2>
          <p style={BODY}>
            本サービス「サイトモックアップ ジェネレーター」は、Web制作を検討されている方が完成イメージを把握するための参考確認ツールです。実際のWeb制作の成果物ではありません。
          </p>

          <h2 style={HEADING}>第2条（生成コンテンツの免責）</h2>
          <ul style={{ ...BODY, paddingLeft: 20 }}>
            <li style={LI}>表示されるテキストはイメージ確認用の仮コピーです</li>
            <li style={LI}>生成結果の正確性・完全性を保証しません</li>
            <li style={LI}>生成結果をそのまま商用利用することはお控えください</li>
            <li style={LI}>実在する人物・企業に関する情報が不正確な場合があります</li>
          </ul>

          <h2 style={HEADING}>第3条（入力URLについて）</h2>
          <ul style={{ ...BODY, paddingLeft: 20 }}>
            <li style={LI}>入力するURLは適法なサイトに限ります</li>
            <li style={LI}>取得した画像・テキストの著作権は元サイトに帰属します</li>
            <li style={LI}>第三者の権利を侵害する目的での利用を禁止します</li>
          </ul>

          <h2 style={HEADING}>第4条（第三者サービス）</h2>
          <p style={BODY}>本サービスは以下の第三者サービスを使用しています：</p>
          <ul style={{ ...BODY, paddingLeft: 20 }}>
            <li style={LI}>Anthropic Claude API（テキスト生成・サイト解析）</li>
            <li style={LI}>Unsplash API（フリー画像の取得）</li>
            <li style={LI}>Google Analytics（アクセス解析）</li>
          </ul>

          <h2 style={HEADING}>第5条（広告の表示について）</h2>
          <p style={BODY}>
            本サービスは、Google AdSenseをはじめとする第三者配信の広告サービスを利用する場合があります。これらの広告配信事業者は、ユーザーの興味に応じた広告を表示するためにCookieを使用することがあります。Cookieを無効にする設定および広告配信事業者のオプトアウトについては、各社のサイトをご確認ください。
          </p>

          <h2 style={HEADING}>第6条（Cookieの使用について）</h2>
          <p style={BODY}>
            本サービスは、ユーザー体験向上、アクセス解析、広告配信のためにCookieを使用します。Cookieの使用を望まない場合は、ブラウザの設定で無効化することができます。ただし、Cookieを無効にすると一部の機能が利用できなくなる場合があります。
          </p>

          <h2 style={HEADING}>第7条（著作権・知的財産権）</h2>
          <p style={BODY}>
            本サービスのデザイン、テンプレート、ソースコード、ロゴ、その他のコンテンツに関する著作権および知的財産権は、髙正堂株式会社または正当な権利者に帰属します。無断での複製・転載・改変・再配布を禁じます。
          </p>

          <h2 style={HEADING}>第8条（禁止事項）</h2>
          <p style={BODY}>ユーザーは以下の行為を禁止します：</p>
          <ul style={{ ...BODY, paddingLeft: 20 }}>
            <li style={LI}>違法・有害なサイトのURLを入力すること</li>
            <li style={LI}>システムへの過度なアクセスや攻撃行為</li>
            <li style={LI}>本サービスを利用した第三者への迷惑行為</li>
            <li style={LI}>本サービスの逆コンパイル、リバースエンジニアリング</li>
            <li style={LI}>本サービスを商用目的で再販・再配布すること</li>
            <li style={LI}>その他、当社が不適切と判断する行為</li>
          </ul>

          <h2 style={HEADING}>第9条（免責事項）</h2>
          <ul style={{ ...BODY, paddingLeft: 20 }}>
            <li style={LI}>当社は本サービスの利用によって生じたいかなる損害についても責任を負いません</li>
            <li style={LI}>本サービスの内容・仕様は予告なく変更される場合があります</li>
            <li style={LI}>本サービスの提供を予告なく停止または終了する場合があります</li>
            <li style={LI}>サーバーやネットワークの障害により、本サービスが一時的に利用できない場合があります</li>
          </ul>

          <h2 style={HEADING}>第10条（プライバシー）</h2>
          <p style={BODY}>
            個人情報の取り扱いについては、別途定める「プライバシーポリシー」に従います。
          </p>

          <h2 style={HEADING}>第11条（規約の変更）</h2>
          <p style={BODY}>
            当社は、必要と判断した場合には、ユーザーに通知することなく本規約を変更することができます。本規約の変更後、本サービスを利用した場合は、変更後の規約に同意したものとみなします。
          </p>

          <h2 style={HEADING}>第12条（準拠法・管轄裁判所）</h2>
          <p style={BODY}>
            本規約の解釈にあたっては日本法を準拠法とし、本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄裁判所とします。
          </p>

          <h2 style={HEADING}>第13条（お問い合わせ）</h2>
          <p style={BODY}>
            本規約に関するお問い合わせは以下までお願いします。<br />
            <a href="mailto:takamasado@gmail.com" style={{ color: '#1e3a5f', textDecoration: 'none' }}>
              takamasado@gmail.com
            </a>
          </p>

        </div>
      </div>

      <Footer />
    </div>
  );
}
